/* ============================================================
   IGNITE — PROMO LABEL + LOCK (v7)  [Focal real markup]

   PASTREAZA logica de sync (p8-v600-promo.js) neatinsa.

   Specific temei Focal (vazut in DOM):
     - randul de cos = <line-item class="line-item">
     - +/- sunt <a class="quantity-selector__button"
              href="/cart/change?quantity=N&line=L">
     - inputul = <input name="updates[]" data-line="N">
     - sterge = <a class="line-item__remove-button"
              href="/cart/change?id=KEY&quantity=0">
     - KEY-ul liniei e in href-ul de "Sterge" (id=KEY)

   Ce face:
   1. Citeste /cart.js -> KEY-urile cu properties._ignite_promo.
   2. Pentru fiecare rand din DOM, extrage KEY-ul din link-ul "Sterge"
      si il compara cu KEY-urile promo (STRICT). V600 manuale (alt KEY)
      raman 100% functionale.
   3. Pe randurile promo:
        - ascunde tot widget-ul de cantitate (+, input, -)
        - ascunde link-ul "Sterge"
        - dezactiveaza inputul
        - adauga eticheta "Cadou promoțional P8"
   4. BLOCANTE GLOBALE (capture phase) care anuleaza ORICE click pe
      link-urile /cart/change (plus/minus/sterge) si pe inputuri din
      randurile promo -> asta omoara butonul "+" definitiv.
      Link-urile catre produs/imagine raman click-abile.
   ============================================================ */

(function () {
  'use strict';

  var LABEL_CLASS   = 'ignite-promo-label';
  var MARKED_ATTR   = 'data-promo-label-injected';
  var PROMO_ATTR    = 'data-promo-item';
  var PROMO_CLASS   = 'is-promo-line-item';
  var LOCK_QTY_ATTR = 'data-promo-locked-qty';
  var LABEL_TEXT    = 'Produs promoțional';

  var promoKeySet = {};

  var ROW_SELECTOR =
    'line-item, .line-item, [class*="cart-item"], .cart__row, ' +
    '.ajaxcart__row, .drawer__item, cart-line-item';

  function log() {
    try {
      if (window.__igniteDebug) {
        console.log.apply(console, ['[PROMO-LOCK v7]'].concat([].slice.call(arguments)));
      }
    } catch (e) {}
  }

  function fetchCartItems() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return cart.items || []; })
      .catch(function () { return []; });
  }

  function isItemPromo(item) {
    return item && item.properties &&
      (item.properties._ignite_promo === 'p8-v600-free' ||
       item.properties._promo_locked === 'true');
  }

  function allRows() {
    return document.querySelectorAll(ROW_SELECTOR);
  }

  /* Extrage KEY-ul liniei dintr-un rand DOM */
  function keyFromRow(row) {
    if (!row || !row.querySelector) return null;

    // 1. Focal: link "Sterge" cu ?id=KEY&quantity=0
    var rm = row.querySelector('a[href*="id="]');
    if (rm) {
      var href = rm.getAttribute('href') || '';
      var m = href.match(/[?&]id=([^&]+)/);
      if (m) return decodeURIComponent(m[1]);
    }

    // 2. teme cu input keyed: name="updates[KEY]"
    var inp = row.querySelector('input[name^="updates["]');
    if (inp) {
      var nm = inp.getAttribute('name') || '';
      var mm = nm.match(/updates\[(.+)\]/);
      if (mm && mm[1]) return mm[1];
    }

    // 3. atribute uzuale
    return row.getAttribute('data-key') ||
           row.getAttribute('data-line-key') ||
           row.getAttribute('data-cart-item-key') ||
           row.getAttribute('data-line-item-key') ||
           null;
  }

  function getLockedQty(el) {
    var existing = el.getAttribute(LOCK_QTY_ATTR);
    if (existing) return existing;
    var input = el.querySelector(
      'input[name^="updates"], input[is="input-number"], input.quantity-selector__input, ' +
      'input[type="number"], input[inputmode="numeric"]'
    );
    var v = (input && input.value) ? input.value : '1';
    el.setAttribute(LOCK_QTY_ATTR, v);
    return v;
  }

  function lockPromoLineItem(el) {
    if (!el) return;
    el.setAttribute(PROMO_ATTR, 'true');
    el.classList.add(PROMO_CLASS);

    var lockedQty = getLockedQty(el);

    // a) input cantitate -> blocat
    el.querySelectorAll(
      'input[name^="updates"], input[is="input-number"], input.quantity-selector__input, ' +
      'input[type="number"], input[inputmode="numeric"]'
    ).forEach(function (inp) {
      try {
        inp.value = lockedQty;
        inp.setAttribute('readonly', 'readonly');
        inp.setAttribute('tabindex', '-1');
        inp.style.setProperty('pointer-events', 'none', 'important');
      } catch (e) {}
    });



    // c) ascunde individual link-urile +/- (siguranta)
    el.querySelectorAll('a.quantity-selector__button, .quantity-selector__button').forEach(function (b) {
      try { b.style.setProperty('display', 'none', 'important'); } catch (e) {}
    });

    // d) ascunde "Sterge"
    el.querySelectorAll(
      '.line-item__remove-button, a[href*="id="][href*="quantity=0"], ' +
      '.cart-item__remove, .cart-remove-button, cart-remove-button, [data-cart-remove]'
    ).forEach(function (b) {
      try { b.style.setProperty('display', 'none', 'important'); } catch (e) {}
    });
  }

  function injectLabel(el) {
    if (el.getAttribute(MARKED_ATTR) === 'true') return;
    if (el.querySelector('.' + LABEL_CLASS)) { el.setAttribute(MARKED_ATTR, 'true'); return; }

    var span = document.createElement('span');
    span.className = LABEL_CLASS;
    span.textContent = LABEL_TEXT;

    var titleHost = el.querySelector(
      '.product-item-meta__title, .cart-item__name, .cart-item__title, ' +
      '.line-item__title, [class*="__title"] a, .product-item-meta a'
    );
    try {
      if (titleHost && titleHost.parentNode) {
        titleHost.parentNode.insertBefore(span, titleHost.nextSibling);
      } else {
        (el.querySelector('.line-item__info, .product-item-meta') || el).appendChild(span);
      }
    } catch (e) {
      try { el.appendChild(span); } catch (e2) {}
    }
    el.setAttribute(MARKED_ATTR, 'true');
  }

  /* ---------- Blocante globale (capture phase) ---------- */

  function promoRowOf(node) {
    if (!node || node.nodeType !== 1 || !node.closest) return null;
    var marked = node.closest('[' + PROMO_ATTR + '="true"]');
    if (marked) return marked;
    var row = node.closest(ROW_SELECTOR);
    if (row) {
      var k = keyFromRow(row);
      if (k && promoKeySet[k]) return row;
    }
    return null;
  }

  /* True doar pentru controalele de cantitate / sterge — NU pentru
     link-urile catre produs sau imagine. */
  function isBlockedControl(node, row) {
    var el = node;
    while (el && el !== row && el.nodeType === 1) {
      if (el.matches) {
        if (el.matches(
          '.quantity-selector, .quantity-selector__button, .line-item__remove-button, ' +
          'input, button, [data-cart-remove], select'
        )) return true;
        var href = el.getAttribute && el.getAttribute('href');
        if (href && href.indexOf('/cart/change') !== -1) return true; // qty + sterge
      }
      el = el.parentElement;
    }
    return false;
  }

  function blockEvent(e) {
    var row = promoRowOf(e.target);
    if (!row) return;
    if (!isBlockedControl(e.target, row)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
  }

  function blockValueChange(e) {
    var row = promoRowOf(e.target);
    if (!row) return;
    var t = e.target;
    if (t.tagName === 'INPUT' || t.tagName === 'SELECT' || t.tagName === 'TEXTAREA') {
      var locked = row.getAttribute(LOCK_QTY_ATTR) || '1';
      try { t.value = locked; } catch (e2) {}
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }

  ['pointerdown', 'mousedown', 'click', 'touchstart', 'keydown', 'dblclick'].forEach(function (evt) {
    document.addEventListener(evt, blockEvent, true);
  });
  ['change', 'input'].forEach(function (evt) {
    document.addEventListener(evt, blockValueChange, true);
  });

  /* ---------- Proces principal ---------- */

  function process() {
    fetchCartItems().then(function (items) {
      var newSet = {};
      items.forEach(function (it) { if (isItemPromo(it)) newSet[it.key] = true; });
      promoKeySet = newSet;

      allRows().forEach(function (row) {
        var key = keyFromRow(row);
        if (key && promoKeySet[key]) {
          injectLabel(row);
          lockPromoLineItem(row);
        }
      });
    }).catch(function () {});
  }

  function init() {
    process();

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () { scheduled = false; process(); }, 60);
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) { schedule(); return; }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    ['cart:refresh', 'cart:updated', 'cart:change', 'shopify:section:load'].forEach(function (evt) {
      document.addEventListener(evt, schedule);
    });

    setInterval(process, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();